module["exports"] = [
  "#####",
  "####",
  "###",
  "##",
  "#"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_CN/address/building_number.js
 ** module id = 1103
 ** module chunks = 0
 **/